/* Predictive search: include sold-out products.
   theme.js hardcodes the /search/suggest query string and omits
   resources[options][unavailable_products], so it defaults to "last" —
   sold-out products get pushed past resources[limit]=10 and vanish
   (e.g. searching "polerina" returned Ballerina Heels, not Polerina Heels). */
(function () {
  if (window.__dsSuggestParamsPatched) return;
  window.__dsSuggestParamsPatched = true;

  var nativeFetch = window.fetch;
  if (typeof nativeFetch !== "function") return;

  window.fetch = function (resource, init) {
    try {
      var isRequest = typeof Request !== "undefined" && resource instanceof Request;
      var url = isRequest ? resource.url : String(resource);

      if (url.indexOf("/search/suggest") !== -1 &&
          url.indexOf("unavailable_products") === -1) {
        var next = url + "&resources[options][unavailable_products]=show";
        resource = isRequest ? new Request(next, resource) : next;
      }
    } catch (e) {}

    return nativeFetch.call(this, resource, init);
  };
})();
(function () {

  function getEstimatedDelivery() {
    const today = new Date();
    const minDelivery = new Date();
    const maxDelivery = new Date();

    minDelivery.setDate(today.getDate() + 5);
    maxDelivery.setDate(today.getDate() + 10);

    const options = { month: 'long', day: 'numeric' };
    const minDate = minDelivery.toLocaleDateString('en-US', options);
    const maxDate = maxDelivery.toLocaleDateString('en-US', options);

    const dateSpan = document.getElementById('shipping-date');
    if (dateSpan) {
      dateSpan.textContent = `${minDate} - ${maxDate}`;
    }
  }

  function ensureSnippetExists() {
    if (!document.getElementById('shipping-date')) {
      const targetContainer = document.querySelector('.product-form, #ProductForm');
      if (targetContainer) {
        const snippetHTML = `
          <p class="estimated-shipping">
            Estimated delivery: <span id="shipping-date"></span>
          </p>
        `;
        targetContainer.insertAdjacentHTML('beforeend', snippetHTML);
        getEstimatedDelivery();
      }
    }
  }

  // **Check if the URL has changed (variant ID updated)**
  let lastVariant = new URL(window.location.href).searchParams.get("variant");

  function checkURLChange() {
    const currentVariant = new URL(window.location.href).searchParams.get("variant");
    
    if (currentVariant !== lastVariant) {
      lastVariant = currentVariant;
      ensureSnippetExists();
      getEstimatedDelivery();
    }
  }

  // **Run once on page load**
  document.addEventListener('DOMContentLoaded', function () {
    ensureSnippetExists();
    getEstimatedDelivery();
  });

  // **Continuously watch for URL changes**
  setInterval(checkURLChange, 500);

})();

class MegaMenuListener extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = this.querySelector("x-header");
    this.headerHeight = this.header?.offsetHeight;
    this.headerOverlay = this.querySelector(".header-overlay");
    this.menus = this.querySelectorAll(".header__menu-disclosure");
    this.primaryNavs = this.querySelectorAll(".header__primary-nav-item");
    this.dropdowns = this.querySelectorAll(".header__dropdown-menu");

    this.headerOverlay.style.top = `${this.headerHeight}px`

    this.primaryNavs.forEach((nav)=>{
      if(!(nav?.querySelector(".header__dropdown-menu"))){
        nav.addEventListener("mouseover", this.closeAllDropdowns.bind(this));
      }
    })

    this.dropdowns.forEach((dropdown)=>{
      dropdown.setAttribute("data-height", dropdown.clientHeight);
      dropdown.style.height = 0;
      setTimeout(() => {
        dropdown.style.opacity = 1;
      }, 0);
    })

    this.menus.forEach(menu => {

      menu.addEventListener("mouseover", () => {

        this.closeAllDropdowns();
        let dropdown = menu.querySelector(".header__dropdown-menu");
        let height = parseInt(dropdown.dataset.height ?? 0) + 4
        dropdown.style.height = `${height}px`;
        this.headerOverlay.style.height = `${height}px`;
        this.header.style.overflow = "unset";
      })

    });
    this.addEventListener("mouseleave", this.closeAllDropdowns.bind(this));
  }
  closeAllDropdowns(){
    this.dropdowns.forEach((dropdown)=>{
      dropdown.style.height = '0px';
      this.headerOverlay.style.height = '0px';
    })
  }


}

customElements.define('mega-menu-listener', MegaMenuListener);
